import { AppConfigModel } from "../abstract/app-config.model";

export class ItemType extends AppConfigModel {

    static override CLASS_NAME: string = 'ItemType';
}
